import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function ViewWorkspace() {
  const [workspace, setWorkspace] = useState([]);
  const [viewData, setViewData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user?.id) {
      fetchWorkspace();
    }
  }, []);

  /* ================= FETCH WORKSPACE ================= */

  const fetchWorkspace = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user?.id) {
      console.error("User not found");
      return;
    }

    try {
      const res = await fetch(`${API.LIST_WORKSPACES}&user_id=${user.id}`);

      const data = await res.json();

      const formattedData = Array.isArray(data)
        ? data.map((item) => ({
            ...item,
            images: item.image
              ? item.image.split(",").filter((img) => img && img.trim() !== "")
              : [],
          }))
        : [];

      setWorkspace(formattedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  /* ================= EDIT ================= */

  const handleEdit = (item) => {
    navigate("/user/add-workspace", {
      state: { workspace: item },
    });
  };

  /* ================= DELETE ================= */

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this workspace?")) return;

    try {
      const formData = new FormData();
      formData.append("id", id);

      const res = await fetch(API.DELETE_WORKSPACE, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      alert(data.message);

      fetchWorkspace();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2>Manage Workspaces</h2>

      {/* CARD GRID */}
      <div className="product-grid">
        {workspace.length > 0 ? (
          workspace.map((item) => (
            <div className="machine-card" key={item.id}>
              {/* IMAGE */}
              <div className="machine-img-container">
                {item.images[0] && (
                  <img
                    src={`${UPLOADS.WORKSPACE_IMAGE}${item.images[0]}`}
                    alt="workspace"
                  />
                )}

                <span className="heads-badge">₹ {item.rent_price}</span>
              </div>

              {/* BODY */}
              <div className="machine-body">
                <h4 className="machine-name">{item.owner_name}</h4>

                {/* RENT + CONTACT */}
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <div className="price-block">
                    <span className="currency-symbol">₹</span>
                    <span className="amount">
                      {Number(item.rent_price).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <button className="contact-btn">
                    <i className="bi bi-telephone-fill me-1"></i>
                    Contact
                  </button>
                </div>

                {/* LOCATION */}
                <div className="spec-row mt-2">
                  <div className="spec-item">
                    <span className="spec-label">Size:</span>
                    <span className="spec-value">{item.size}</span>
                  </div>

                  <div className="spec-item">
                    <span className="spec-label">Floor:</span>
                    <span className="spec-value">{item.floor}</span>
                  </div>
                </div>

                <div className="location-info">
                  <i className="bi bi-geo-alt-fill"></i>
                  {item.location},{item.city}
                </div>

                {/* STATUS */}
                <div className="mt-2">
                  <span className={`status ${item.status?.toLowerCase()}`}>
                    {item.status}
                  </span>
                </div>

                {/* ACTION BUTTONS */}
                <div className="machine-actions mt-3">
                  <button
                    className="action-btn view-action"
                    onClick={() => setViewData(item)}
                    title="View"
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>

                  <button
                    className="action-btn edit-action"
                    onClick={() => handleEdit(item)}
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete-action"
                    onClick={() => handleDelete(item.id)}
                    title="Delete"
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Workspaces Found</p>
        )}
      </div>

      {/* ================= VIEW POPUP ================= */}

      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Workspace Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{viewData.owner_name}</p>
              </div>
              <div>
                <label>Phone</label>
                <p>{viewData.phone}</p>
              </div>
              <div>
                <label>City</label>
                <p>{viewData.city}</p>
              </div>
              <div>
                <label>State</label>
                <p>{viewData.state}</p>
              </div>
              <div>
                <label>Address</label>
                <p>{viewData.address}</p>
              </div>
              <div>
                <label>Room Size</label>
                <p>{viewData.size}</p>
              </div>
              <div>
                <label>Floor</label>
                <p>{viewData.floor}</p>
              </div>
              <div>
                <label>Rent</label>
                <p>₹ {viewData.rent_price}</p>
              </div>
              <div>
                <label>Location</label>
                <p>{viewData.location}</p>
              </div>
            </div>

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>

            <div className="popup-images">
              {viewData.images &&
                viewData.images.map((img, i) => (
                  <img
                    key={i}
                    src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                    alt="workspace"
                  />
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
